<template>
  <div>
    <div v-if="!isLoading && indexList">
      <LlAppFixedToolBar/>
      <LlScrollableWrap>
        <LlScrollableBlock :title="$t(`${query.pageTitle}`)">
          <ListCard
            isTable
            bigTitle
            noPadding
            hasBorderBottom
            class="mt-0 pb-0"
          >
            <ListCardItem
              v-for="(field, fieldKey) in indexList.primary"
              :key="fieldKey"
              row
              isTable
              printTable
              type="text"
              :title="$t(`${field.title}`)"
              :text-content="$t(`${field.data}`)"
            />
          </ListCard>
          <ListCard
            isTable
            noPadding
            :hasBorderBottom="indexList.third !== undefined"
            class="mt-0 mb-40"
          >
            <ListCardItem
              v-for="(field, fieldKey) in indexList.secondary"
              :key="fieldKey"
              row
              isTable
              printTable
              type="text"
              :title="$t(`${field.title}`)"
              :text-content="$t(`${field.data}`)"
            />
          </ListCard>
          <div
            v-for="(field, fieldKey) in indexList.third"
            :key="fieldKey"
          >
            <slot 
              :field="field"
              name="component"
            />
          </div>
        </LlScrollableBlock>
      </LlScrollableWrap>
    </div>
    <PopUp
      :title="$t('列印準備完成。')"
      :popUpActive="isActive.popup"
      class="hide"
      @click="$_onClosePopup('popup')"
    >
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001
            @click="$_onPrint()"
          >
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>
<script>
import S_printing from '@/service/api/v1/printing';

export default {
  name: "PrintModelLayout",
  data() {
    return {
      indexList: null,
      apiData: null,
      isLoading: true,
      isActive: {
        popup: false,
      }
    };
  },
  props:{
    query:{
      type: Object
    },
    printField:{
      type: Object
    }
  },
  async mounted() {
    await this.$_init();
  },
  methods:{
    $_onPrint() {
      if (this.isActive.popup) this.$_onClosePopup('popup');
      window.print();
    },
    async $_init() {
      try {
        this.apiData = await S_printing[`${this.query.apiFetchFunction}`](this.query);
        this.indexList = await S_printing[`${this.query.fieldDataFunction}`](this.apiData, this.printField, this.query);
        this.isLoading = false;
        this.$_onOpenPopup('popup');
      } catch (error) {
        this.isLoading = false;
        console.error(error);
      }
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      this.isActive[type] = false;
    }
  },
  computed: {
    _allSystemClasses(){
      return this.$store.state.model.systemClasses;
    },
  },
};
</script>

<style scoped lang="scss">
  @media print {
    * {
      -webkit-print-color-adjust: exact !important;
    }
    .noBreak {
      .ll-diplay-collapse-list_content{
        .ll-display-list_content-item{
          break-inside: avoid;
          .leadingIcon{
            break-inside: avoid;
          }
        }
      }
    }
    .hide {
      display: none;
    }
  }
  @page {
    size: A4 landscape;
    margin: 15px 0 15px 0 ;
  }
</style>